import React from 'react';
import { Menu } from 'antd';
import styled from 'styled-components';
import { useLocation, Link } from 'react-router-dom';

const keys = ['dashboard', 'settings', 'teams', 'history'];

export default function SubMenu() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const selectedKey =
    keys.find(key => pathSegments.includes(key)) || 'live-chat';

  return (
    <LiveChatSubMenu
      defaultSelectedKeys={['1']}
      selectedKeys={[selectedKey]}
      mode="horizontal"
    >
      <Menu.Item key="live-chat">
        <Link to="/live-chat">Chat</Link>
      </Menu.Item>
      <Menu.Item key="dashboard">
        <Link to="/live-chat/dashboard">Dashboard</Link>
      </Menu.Item>
      <Menu.Item key="teams">
        <Link to="/teams">Teams</Link>
      </Menu.Item>
      <Menu.Item key="history">
        <Link to="/history">History</Link>
      </Menu.Item>
      <Menu.Item key="settings">
        <Link to="/teams/settings">Settings</Link>
      </Menu.Item>
    </LiveChatSubMenu>
  );
}

const LiveChatSubMenu = styled(Menu)`
  flex-grow: 0;

  &.ant-menu-horizontal {
    border: none;
    background: transparent;
    padding: 20px 10px 0 20px;
    font-weight: 500;
    font-size: 16px;
  }
`;
